export interface Procedures {
    id: number;
    name: string;
    max_implants: number | null,
    min_implants: number | null,
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}